/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserVm
 */
export interface UserVm {
    /**
     * 
     * @type {string}
     * @memberof UserVm
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserVm
     */
    familyname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserVm
     */
    middlename?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserVm
     */
    forename?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserVm
     */
    username?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserVm
     */
    pwdHash?: string | null;
}

export function UserVmFromJSON(json: any): UserVm {
    return UserVmFromJSONTyped(json, false);
}

export function UserVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'familyname': !exists(json, 'familyname') ? undefined : json['familyname'],
        'middlename': !exists(json, 'middlename') ? undefined : json['middlename'],
        'forename': !exists(json, 'forename') ? undefined : json['forename'],
        'username': !exists(json, 'username') ? undefined : json['username'],
        'pwdHash': !exists(json, 'pwdHash') ? undefined : json['pwdHash'],
    };
}

export function UserVmToJSON(value?: UserVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'familyname': value.familyname,
        'middlename': value.middlename,
        'forename': value.forename,
        'username': value.username,
        'pwdHash': value.pwdHash,
    };
}


